import { ItensPedido } from '../model/ItensPedido'
export class Pedido {
    public Usuario: any;
    public UsuarioFK: string;
    public Vendedor: any;
    public VendedorFK: string;
    public nrPedido: string;
    public data: Date;
    public Itens: ItensPedido[];    
    constructor() {
        this.Itens = new Array<ItensPedido>();
    }

    get Total(): number {
        var rt: number = 0;
        this.Itens.forEach(it => {
            rt = Number(Number(rt) + Number(it.quantidade));
        })
        return rt;
    }

    get VrTotal(): number {
        var rt: number = 0;
        this.Itens.forEach(it => {
            rt = Number(Number(rt) + Number(it.vrTotal));
        })
        return rt;
    }

    public Assing(item)
    {
        this.nrPedido = item.nrPedido;
        this.data = item.data;
        this.UsuarioFK = item.usuarioFK;
        this.Usuario = item.usuario;
        this.VendedorFK = item.vendedorFK;
        this.Vendedor = item.vendedor;
        if (item.itens)
        {
            this.Itens = new Array<ItensPedido>();
            item.itens.forEach(i => {
                var it = new ItensPedido();
                it.Assing(i);
                this.Itens.push(it);
            });
        }
    }

    public AddItem(idProduto:string, codProduto : string, descricao:string, quantidade:number, vrUnitario: number, empresa: string, qtdePorCaixa: number)
    {        
        var item = this.Itens.find(function(e){return e.produtoId == idProduto});
        if (item)
        {
            item.quantidade = Number(Number(item.quantidade) + Number(quantidade));
        }
        else
        {
            item = new ItensPedido();
            item.produtoId = idProduto;
            item.codProduto = codProduto;
            item.descricao = descricao;
            item.quantidade = quantidade;
            item.data = new Date();
            item.vrUnitario = vrUnitario;  
            item.tipoProduto = empresa;
            item.qtdePorCaixa = qtdePorCaixa;
            this.Itens.push(item);
            this.Sort();
        }
        
    }

    private Sort()
    {
        this.Itens.sort(function (a, b) {
            return a.data > b.data ? -1 : a.data < b.data ? 1 : 0;
          });
    }
}
